module.exports = __webpack_public_path__ + "img/mappa-totem-3-small.fada915e.jpg";